import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { load, JSON_SCHEMA } from 'js-yaml';
import { severityToPill } from './issue-type';
import { STEPJSON_READ_CONCURRENCY } from '../config';
import { PackError } from '../pack/errors';
// JSON_SCHEMA keeps unquoted timestamps (kane writes `ended:` unquoted) as
// plain strings instead of Date objects, and `browser_version: '143'` stays a
// string. Unknown keys are always ignored (contract: additive evolution).
var yamlParse = function yamlParse(text) {
  return load(text, {
    schema: JSON_SCHEMA
  });
};
function asRecord(v) {
  return v !== null && _typeof(v) === 'object' && !Array.isArray(v) ? v : null;
}
var asString = function asString(v) {
  return typeof v === 'string' && v !== '' ? v : undefined;
};

/** Loose string coercion for open external_id values ("8827490" or 8827490). */
var asIdString = function asIdString(v) {
  return typeof v === 'string' && v !== '' ? v : typeof v === 'number' ? String(v) : undefined;
};

/**
 * Parse run.yaml text. Throws typed errors when it isn't a readable evidence
 * manifest. Accepts any 0.x contract (additive minors); rejects other majors
 * loudly rather than mis-reading them (spec: reject-don't-misread).
 */
export function parseRunManifest(yaml) {
  var doc;
  try {
    doc = asRecord(yamlParse(yaml));
  } catch (_unused) {
    throw new PackError('not-a-pack', 'run.yaml is not parseable YAML');
  }
  if (!doc || typeof doc.evidence !== 'string' || typeof doc.run_id !== 'string') {
    throw new PackError('not-a-pack', 'not an evidence run.yaml (missing evidence/run_id)');
  }
  if (!/^0\./.test(doc.evidence)) {
    throw new PackError('unsupported-version', "this viewer reads evidence 0.x; the pack declares \"".concat(doc.evidence, "\""), {
      found: doc.evidence
    });
  }
  return doc;
}

/** Parse tests/<id>/result.yaml text. */
export function parseTestResult(yaml) {
  var doc;
  try {
    doc = asRecord(yamlParse(yaml));
  } catch (_unused2) {
    throw new PackError('not-a-pack', 'result.yaml is not parseable YAML');
  }
  if (!doc || typeof doc.test !== 'string') {
    throw new PackError('not-a-pack', 'not an evidence result.yaml (missing test)');
  }
  return doc;
}
var TEST_STATUSES = ['passed', 'failed', 'broken', 'skipped'];
export function normalizeTestStatus(s) {
  return TEST_STATUSES.includes(s) ? s : 'unknown';
}
function normalizeLifecycle(s) {
  return s === 'running' || s === 'finalized' || s === 'aborted' ? s : 'unknown';
}
function parseInstant(s) {
  if (typeof s !== 'string') return null;
  var t = Date.parse(s);
  return Number.isNaN(t) ? null : t;
}

/**
 * Derive the run-level chip. `status` is a lifecycle, so a finalized run's
 * displayed verdict comes from the authored totals — broken is never
 * collapsed into failed.
 */
function deriveChip(lifecycle, totals) {
  if (lifecycle === 'running') return {
    kind: 'lifecycle',
    lifecycle: lifecycle
  };
  if (lifecycle === 'aborted') return {
    kind: 'lifecycle',
    lifecycle: lifecycle
  };
  if (totals.failed > 0) return {
    kind: 'verdict',
    verdict: 'failed'
  };
  if (totals.broken > 0) return {
    kind: 'verdict',
    verdict: 'broken'
  };
  if (totals.passed > 0) return {
    kind: 'verdict',
    verdict: 'passed'
  };
  return {
    kind: 'verdict',
    verdict: 'skipped'
  };
}
export function toRunVM(m) {
  var _m$totals$tests, _m$totals, _m$totals$passed, _m$totals2, _m$totals$failed, _m$totals3, _m$totals$broken, _m$totals4, _m$totals$skipped, _m$totals5, _m$environment, _asString, _asString2, _asString3, _asString4;
  var totals = {
    tests: (_m$totals$tests = (_m$totals = m.totals) === null || _m$totals === void 0 ? void 0 : _m$totals.tests) !== null && _m$totals$tests !== void 0 ? _m$totals$tests : 0,
    passed: (_m$totals$passed = (_m$totals2 = m.totals) === null || _m$totals2 === void 0 ? void 0 : _m$totals2.passed) !== null && _m$totals$passed !== void 0 ? _m$totals$passed : 0,
    failed: (_m$totals$failed = (_m$totals3 = m.totals) === null || _m$totals3 === void 0 ? void 0 : _m$totals3.failed) !== null && _m$totals$failed !== void 0 ? _m$totals$failed : 0,
    broken: (_m$totals$broken = (_m$totals4 = m.totals) === null || _m$totals4 === void 0 ? void 0 : _m$totals4.broken) !== null && _m$totals$broken !== void 0 ? _m$totals$broken : 0,
    skipped: (_m$totals$skipped = (_m$totals5 = m.totals) === null || _m$totals5 === void 0 ? void 0 : _m$totals5.skipped) !== null && _m$totals$skipped !== void 0 ? _m$totals$skipped : 0
  };
  var lifecycle = normalizeLifecycle(m.status);
  var started = parseInstant(m.started);
  var ended = parseInstant(m.ended);
  var environment = (_m$environment = m.environment) !== null && _m$environment !== void 0 ? _m$environment : {};
  var producer = asRecord(environment.producer);
  return {
    runId: m.run_id,
    contractVersion: m.evidence,
    title: (_asString = asString(m.title)) !== null && _asString !== void 0 ? _asString : m.run_id,
    lifecycle: lifecycle,
    chip: deriveChip(lifecycle, totals),
    totals: totals,
    passRatePct: totals.tests > 0 ? Math.round(totals.passed / totals.tests * 100) : null,
    durationMs: started !== null && ended !== null && ended >= started ? ended - started : null,
    producerName: producer ? (_asString2 = asString(producer.name)) !== null && _asString2 !== void 0 ? _asString2 : null : null,
    startedAt: (_asString3 = asString(m.started)) !== null && _asString3 !== void 0 ? _asString3 : null,
    endedAt: (_asString4 = asString(m.ended)) !== null && _asString4 !== void 0 ? _asString4 : null,
    flakyCount: null,
    environment: environment
  };
}
function toRowEnv(env) {
  if (!env) return undefined;
  var row = {
    os: asString(env.os),
    osVersion: asIdString(env.os_version),
    browser: asString(env.browser),
    browserVersion: asIdString(env.browser_version),
    resolution: asString(env.resolution),
    platform: asString(env.platform)
  };
  return Object.values(row).some(function (v) {
    return v !== undefined;
  }) ? row : undefined;
}

/**
 * Project a parsed result.yaml onto the row the list renders. Status is the
 * AUTHORED value only (never derived from steps); duration falls back to the
 * sum of the steps' authored durations (steps may be empty or partial).
 */
export function toTestRow(id, r) {
  var _asRecord, _asRecord2;
  var externalId = (_asRecord = asRecord(r.external_id)) !== null && _asRecord !== void 0 ? _asRecord : undefined;
  var steps = Array.isArray(r.steps) ? r.steps : [];
  var stepDurations = steps.map(function (s) {
    return typeof (s === null || s === void 0 ? void 0 : s.duration_ms) === 'number' ? s.duration_ms : null;
  }).filter(function (d) {
    return d !== null;
  });
  var durationMs = typeof r.duration_ms === 'number' ? r.duration_ms : stepDurations.length > 0 ? stepDurations.reduce(function (a, b) {
    return a + b;
  }, 0) : undefined;
  return {
    id: id,
    state: 'loaded',
    status: normalizeTestStatus(r.status),
    title: externalId && asString(externalId.session_name) || id,
    testcaseId: externalId ? asIdString(externalId.testcase_id) : undefined,
    externalId: externalId,
    env: toRowEnv((_asRecord2 = asRecord(r.environment)) !== null && _asRecord2 !== void 0 ? _asRecord2 : undefined),
    durationMs: durationMs,
    stepCount: steps.length,
    flaky: r.flaky === true
  };
}
export function pendingRow(id) {
  return {
    id: id,
    state: 'pending',
    status: 'unknown',
    title: id
  };
}
export function errorRow(id, message) {
  return {
    id: id,
    state: 'error',
    status: 'unknown',
    title: id,
    errorMessage: message
  };
}

/**
 * List a test's steps in ordinal order, each hydrated from its step.json and
 * carrying its screenshot's pack-root-relative path when one exists.
 * Permissive by design: a folder with a broken/missing step.json still shows
 * up (bare ordinal), and a missing screenshot is simply omitted. Detail-view
 * concern — never called during list hydration.
 */
export function listSteps(_x, _x2) {
  return _listSteps.apply(this, arguments);
}

/** Run `fn` over `items` with at most `limit` in flight — a step listing on a
 * 500-step test must not open hundreds of concurrent ranged reads. */
function _listSteps() {
  _listSteps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pack, testId) {
    var stepsDir, folders, infos;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          stepsDir = "tests/".concat(testId, "/steps");
          _context2.next = 1;
          return pack.listDir(stepsDir);
        case 1:
          folders = _context2.sent.filter(function (e) {
            return e.isDir;
          });
          _context2.next = 2;
          return mapPool(folders, STEPJSON_READ_CONCURRENCY, /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(folder) {
              var ordinal, base, children, shot, annotated, raw, j, _iterator, _step, k, coords, rect;
              return _regeneratorRuntime.wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    ordinal = parseInt(folder.name, 10);
                    base = {
                      dirName: folder.name,
                      ordinal: Number.isNaN(ordinal) ? 0 : ordinal
                    };
                    _context.next = 1;
                    return pack.listDir("".concat(stepsDir, "/").concat(folder.name));
                  case 1:
                    children = _context.sent;
                    shot = children.find(function (c) {
                      return !c.isDir && c.name.startsWith('screenshot.');
                    });
                    if (shot) base.screenshotPath = "".concat(stepsDir, "/").concat(folder.name, "/").concat(shot.name);
                    annotated = children.find(function (c) {
                      return !c.isDir && c.name.startsWith('annotated.');
                    });
                    if (annotated) {
                      base.annotatedPath = "".concat(stepsDir, "/").concat(folder.name, "/").concat(annotated.name);
                    }
                    _context.next = 2;
                    return pack.readText("".concat(stepsDir, "/").concat(folder.name, "/step.json"));
                  case 2:
                    raw = _context.sent;
                    if (raw) {
                      try {
                        j = asRecord(JSON.parse(raw));
                        if (j) {
                          _iterator = _createForOfIteratorHelper(['id', 'kind', 'status', 'summary', 'url']);
                          try {
                            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                              k = _step.value;
                              if (typeof j[k] === 'string') base[k] = j[k];
                            }
                          } catch (err) {
                            _iterator.e(err);
                          } finally {
                            _iterator.f();
                          }
                          if (typeof j.duration_ms === 'number') {
                            base.duration_ms = j.duration_ms;
                          }
                          if (typeof j.action_id === 'string') base.actionId = j.action_id;
                          coords = asRecord(j.coordinates);
                          if (coords && typeof coords.x === 'number' && typeof coords.y === 'number') {
                            base.coordinates = {
                              x: coords.x,
                              y: coords.y
                            };
                          }
                          rect = asRecord(j.element_rect);
                          if (rect && typeof rect.x === 'number' && typeof rect.y === 'number' && typeof rect.width === 'number' && typeof rect.height === 'number') {
                            base.elementRect = {
                              x: rect.x,
                              y: rect.y,
                              width: rect.width,
                              height: rect.height
                            };
                          }
                        }
                      } catch (_unused5) {
                        // Unparseable step.json — keep the bare folder info.
                      }
                    }
                    return _context.abrupt("return", base);
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x1) {
              return _ref2.apply(this, arguments);
            };
          }());
        case 2:
          infos = _context2.sent;
          return _context2.abrupt("return", infos.sort(function (a, b) {
            return a.ordinal - b.ordinal;
          }));
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _listSteps.apply(this, arguments);
}
function mapPool(_x3, _x4, _x5) {
  return _mapPool.apply(this, arguments);
}
function _mapPool() {
  _mapPool = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(items, limit, fn) {
    var out, next, worker;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          out = new Array(items.length);
          next = 0;
          worker = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var i;
              return _regeneratorRuntime.wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!(next < items.length)) {
                      _context3.next = 2;
                      break;
                    }
                    i = next;
                    next += 1;
                    _context3.next = 1;
                    return fn(items[i]);
                  case 1:
                    out[i] = _context3.sent;
                    _context3.next = 0;
                    break;
                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function worker() {
              return _ref3.apply(this, arguments);
            };
          }();
          _context4.next = 1;
          return Promise.all(Array.from({
            length: Math.min(limit, items.length)
          }, worker));
        case 1:
          return _context4.abrupt("return", out);
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _mapPool.apply(this, arguments);
}
function formatFromExtension(file) {
  if (file.endsWith('.ndjson')) return 'ndjson';
  if (file.endsWith('.json')) return 'json';
  return 'log';
}

/**
 * The test's log index from logs/meta.yaml; falls back to listing logs/
 * when the index is absent (format guessed from the extension).
 */
export function listLogs(_x6, _x7) {
  return _listLogs.apply(this, arguments);
}

/** Parse the root failure.yaml index. Returns null (never throws) on any
 * shape problem — attention data must never break the run view. */
function _listLogs() {
  _listLogs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(pack, testId) {
    var logsDir, metaText, doc, logs, refs, _iterator2, _step2, l, r;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          logsDir = "tests/".concat(testId, "/logs");
          _context5.next = 1;
          return pack.readText("".concat(logsDir, "/meta.yaml"));
        case 1:
          metaText = _context5.sent;
          if (!metaText) {
            _context5.next = 2;
            break;
          }
          doc = null;
          try {
            doc = asRecord(yamlParse(metaText));
          } catch (_unused6) {
            // fall through to directory listing
          }
          if (!doc) {
            _context5.next = 2;
            break;
          }
          logs = Array.isArray(doc.logs) ? doc.logs : [];
          refs = [];
          _iterator2 = _createForOfIteratorHelper(logs);
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              l = _step2.value;
              r = asRecord(l);
              if (r && typeof r.file === 'string') {
                refs.push({
                  name: typeof r.name === 'string' ? r.name : r.file,
                  file: r.file,
                  format: typeof r.format === 'string' ? r.format : formatFromExtension(r.file)
                });
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return _context5.abrupt("return", refs);
        case 2:
          _context5.next = 3;
          return pack.listDir(logsDir);
        case 3:
          return _context5.abrupt("return", _context5.sent.filter(function (e) {
            return !e.isDir;
          }).map(function (e) {
            return {
              name: e.name.replace(/\.[^.]+$/, ''),
              file: e.name,
              format: formatFromExtension(e.name)
            };
          }));
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _listLogs.apply(this, arguments);
}
export function parseFailureIndex(yaml) {
  try {
    var doc = asRecord(yamlParse(yaml));
    if (!doc || !Array.isArray(doc.failures)) return null;
    return doc;
  } catch (_unused3) {
    return null;
  }
}

/** One `{ref, step}` log pointer from the mechanical core. */
function toLogRef(v) {
  var _ref;
  var rec = asRecord(v);
  var ref = rec ? asString(rec.ref) : undefined;
  if (!ref) return undefined;
  return {
    ref: ref,
    step: (_ref = rec && asString(rec.step)) !== null && _ref !== void 0 ? _ref : null
  };
}

/**
 * The full per-step failure.yaml record (mechanical core + triage block).
 * `step` is the page-state anchor the verdict named as culprit — it may be
 * mechanically "passed" in result.yaml (the status_disagrees advisory).
 */
export function parseFailureDetail(yaml) {
  try {
    var doc = asRecord(yamlParse(yaml));
    if (!doc) return {};
    var error = asRecord(doc.error);
    var pageState = asRecord(doc.page_state);
    var triage = asRecord(doc.triage);
    var by = triage ? asRecord(triage.by) : null;
    var rca = triage ? asRecord(triage.rca) : null;
    var fix = triage ? asRecord(triage.suggested_fix) : null;
    var confidence = rca === null || rca === void 0 ? void 0 : rca.confidence;
    return {
      message: error ? asString(error.message) : undefined,
      rootCause: rca ? asString(rca.root_cause) : undefined,
      triageStatus: triage ? asString(triage.status) : undefined,
      suggestedFix: fix ? asString(fix.summary) : undefined,
      step: asString(doc.step),
      title: asString(doc.title),
      category: rca ? asString(rca.category) : undefined,
      confidence: typeof confidence === 'number' && Number.isFinite(confidence) ? confidence : undefined,
      pageUrl: pageState ? asString(pageState.url) : undefined,
      screenshot: pageState ? asString(pageState.screenshot) : undefined,
      consoleRef: toLogRef(doc.console_at_failure),
      networkRef: toLogRef(doc.network_at_failure),
      severity: triage ? asString(triage.severity) : undefined,
      triagedById: by ? asString(by.id) : undefined,
      triagedAt: by ? asString(by.at) : undefined
    };
  } catch (_unused4) {
    return {};
  }
}
var normalizeTriage = function normalizeTriage(s) {
  return s === 'triaged' || s === 'untriaged' ? s : 'unknown';
};

/**
 * Assemble the "Need your attention" view-model: the root failure.yaml
 * index plus each referenced per-step detail (a handful of ~1 KB ranged
 * reads). Returns null when the pack carries no failure data — the widget
 * hides. Per-item failures degrade to id-based titles, never to an error.
 */
export function readAttention(_x8, _x9, _x0) {
  return _readAttention.apply(this, arguments);
}
function _readAttention() {
  _readAttention = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(pack, maxItems, onIndex) {
    var _index$failures;
    var indexText, index, refs, toItem, toVM, items;
    return _regeneratorRuntime.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 1;
          return pack.readText('failure.yaml');
        case 1:
          indexText = _context7.sent;
          if (!(indexText === null)) {
            _context7.next = 2;
            break;
          }
          return _context7.abrupt("return", null);
        case 2:
          index = parseFailureIndex(indexText);
          if (index) {
            _context7.next = 3;
            break;
          }
          return _context7.abrupt("return", null);
        case 3:
          refs = ((_index$failures = index.failures) !== null && _index$failures !== void 0 ? _index$failures : []).slice(0, maxItems);
          toItem = function toItem(ref, detail) {
            var _asString5, _ref4, _ref5, _detail$title, _detail$severity, _detail$triageStatus, _detail$step;
            var testId = (_asString5 = asString(ref.test)) !== null && _asString5 !== void 0 ? _asString5 : 'unknown-test';
            var fallbackTitle = ref.ordinal !== undefined ? "".concat(testId, " \u2014 step ").concat(ref.ordinal, " failed") : "".concat(testId, " \u2014 failure");
            return {
              testId: testId,
              ordinal: typeof ref.ordinal === 'number' ? ref.ordinal : undefined,
              // Bug name when authored (record, then the seal-time index lift),
              // else the raw error, else the id-based fallback.
              title: (_ref4 = (_ref5 = (_detail$title = detail.title) !== null && _detail$title !== void 0 ? _detail$title : asString(ref.title)) !== null && _ref5 !== void 0 ? _ref5 : detail.message) !== null && _ref4 !== void 0 ? _ref4 : fallbackTitle,
              severity: severityToPill((_detail$severity = detail.severity) !== null && _detail$severity !== void 0 ? _detail$severity : asString(ref.severity)),
              triageStatus: normalizeTriage((_detail$triageStatus = detail.triageStatus) !== null && _detail$triageStatus !== void 0 ? _detail$triageStatus : asString(ref.triage_status)),
              rootCause: detail.rootCause,
              stepId: (_detail$step = detail.step) !== null && _detail$step !== void 0 ? _detail$step : asString(ref.step),
              status: ref.status === 'broken' ? 'broken' : 'failed',
              path: asString(ref.path),
              category: detail.category,
              confidence: detail.confidence,
              triagedAt: detail.triagedAt
            };
          };
          toVM = function toVM(items) {
            var _index$totals$failure, _index$totals, _index$totals$triaged, _index$totals2, _index$totals$untriag, _index$totals3;
            return {
              totals: {
                failures: (_index$totals$failure = (_index$totals = index.totals) === null || _index$totals === void 0 ? void 0 : _index$totals.failures) !== null && _index$totals$failure !== void 0 ? _index$totals$failure : items.length,
                triaged: (_index$totals$triaged = (_index$totals2 = index.totals) === null || _index$totals2 === void 0 ? void 0 : _index$totals2.triaged) !== null && _index$totals$triaged !== void 0 ? _index$totals$triaged : 0,
                untriaged: (_index$totals$untriag = (_index$totals3 = index.totals) === null || _index$totals3 === void 0 ? void 0 : _index$totals3.untriaged) !== null && _index$totals$untriag !== void 0 ? _index$totals$untriag : 0
              },
              items: items
            };
          };
          if (!(refs.length === 0)) {
            _context7.next = 4;
            break;
          }
          return _context7.abrupt("return", null);
        case 4:
          // Two-phase hydration: the index alone (ONE read) already carries rows
          // (title, step, triage status) — publish them immediately so the report
          // block and Issues tab render without waiting for the per-step record
          // reads, which then enrich in place (type chip, confidence, root cause).
          onIndex === null || onIndex === void 0 || onIndex(toVM(refs.map(function (ref) {
            return toItem(ref, {});
          })));
          _context7.next = 5;
          return Promise.all(refs.map(/*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ref) {
              var detail, text, _t;
              return _regeneratorRuntime.wrap(function (_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    detail = {};
                    if (!asString(ref.path)) {
                      _context6.next = 4;
                      break;
                    }
                    _context6.prev = 1;
                    _context6.next = 2;
                    return pack.readText(ref.path);
                  case 2:
                    text = _context6.sent;
                    if (text !== null) detail = parseFailureDetail(text);
                    _context6.next = 4;
                    break;
                  case 3:
                    _context6.prev = 3;
                    _t = _context6["catch"](1);
                  case 4:
                    return _context6.abrupt("return", toItem(ref, detail));
                  case 5:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6, null, [[1, 3]]);
            }));
            return function (_x10) {
              return _ref6.apply(this, arguments);
            };
          }()));
        case 5:
          items = _context7.sent;
          return _context7.abrupt("return", toVM(items));
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _readAttention.apply(this, arguments);
}